module.exports = __webpack_public_path__ + "static/media/prof-pic-1.b5619361.jpg";